// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__25POc","rightAdornment":"Header_rightAdornment__1hlW1"};